/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_No_Valid_Order_IdsInputs */

const en_orders_no_valid_order_ids = /** @type {(inputs: Orders_No_Valid_Order_IdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No valid order IDs found`)
};

const es_orders_no_valid_order_ids = /** @type {(inputs: Orders_No_Valid_Order_IdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron IDs de pedido validos`)
};

/**
* | output |
* | --- |
* | "No valid order IDs found" |
*
* @param {Orders_No_Valid_Order_IdsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_no_valid_order_ids = /** @type {((inputs?: Orders_No_Valid_Order_IdsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_No_Valid_Order_IdsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_no_valid_order_ids(inputs)
	return es_orders_no_valid_order_ids(inputs)
});